import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { Categories } from '@types-lib';
import { ENVIRONMENT, PIMSEnvironment } from 'environments';

export class ProductsCategoriesEndpoint {
  private env = inject<PIMSEnvironment>(ENVIRONMENT);
  http = inject(HttpClient);

  get() {
    return this.http.get<Categories.Category[]>(`${this.env.constants.API_URL}/products/categories`);
  }
}
